import React, { FC, useCallback, useState } from 'react';
import * as classes from './Header.module.scss';
import Container from '../../../../Common/Container/Container';
import cn from 'classnames';
import NavList from '../../../../Common/NavList/NavList';
import LanguageSwitcher from '../../../../Common/LanguageSwitcher/LanguageSwitcher';
import MobileMenu from '../../../../Common/MobileMenu/MobileMenu';
import MenuBurger from '../../../../../assets/icons/inline/burger.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../interfaces/RootState';
import ButtonSize from '../../../../../enums/ButtonSize';
import Link from '../../../../Common/Link/Link';
import DefaultButton from '../DefaultButton/DefaultButton';

interface Props {
  logoText: string;
}

const Header: FC<Props> = ({ logoText }) => {
  const { t } = useTranslation();
  const { mainMenu, mobileMenu } = useSelector((state: RootState) => state.nav);
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  const mobileMenuToggle = useCallback(() => {
    setMobileMenuIsOpen(!mobileMenuIsOpen);
  }, [mobileMenuIsOpen]);

  return (
    <header className={classes.wrapper}>
      <Container>
        <div className={cn(classes.header, 'row')}>
          <div className={cn('col-xl-4 col-md-4 col-6 d-flex align-items-center', classes.logo)}>
            <Link path={'/'}>{logoText}</Link>
          </div>
          <div className={cn('col-xl-4 col-md-4', classes.navWrapper)}>
            <NavList items={mainMenu.items} />
          </div>
          <div className={cn(classes.actionsWrapper, 'col-xl-4 col-md-4')}>
            <div className={classes.langSwitcher}>
              <LanguageSwitcher />
            </div>
            <DefaultButton
              withoutIcon
              size={ButtonSize.SMALL}
              link={{ path: t('header.menu.getInTouch.url'), title: t('header.menu.getInTouch.title') }}
            >
              {t('header.menu.getInTouch.label')}
            </DefaultButton>
          </div>
          <div className={cn(classes.mobileMenuActions, 'col-6')}>
            <div className={classes.mobileMenuTitle}>{t('header.mobileMenuLabel')}</div>
            <div onClick={mobileMenuToggle} className={classes.burger}>
              <MenuBurger />
            </div>
          </div>
        </div>
      </Container>
      <MobileMenu isOpen={mobileMenuIsOpen} closeMenuAction={mobileMenuToggle} mainMenuItems={mobileMenu.items} logoText={logoText} />
    </header>
  );
};

export default Header;
